<template>
  <div>
    <timeslice-player v-if="timesliceRecording" :timeslice-recorging="timesliceRecording" />
  </div>
</template>

<script>
  import {timesliceExampleRecording} from "../services/modules/timeslice-recording";
  import TimeslicePlayer from "../components/timeslice/TimeslicePlayer";
  import {getTimesliceRecording} from "../services/apollo/timeslice";

  export default {
    name: 'TimeslicePlayerPage',
    components: {TimeslicePlayer},
    props: {
      id: {
        type: String
      }
    },
    data: () => ({
      timesliceExampleRecording,
      timesliceRecording: null
    }),
    created() {
      getTimesliceRecording(this.id)
        .then(({recording}) => {
          this.timesliceRecording = recording
        })
        .catch((err) => {
          console.log(err)
        })
    }
  }
</script>

<style scoped>

</style>
